import { AbstractControl, ValidationErrors } from '@angular/forms';

export const fileSizeConverter = (input: number | string): string => {
    const sizeInKB = typeof input === 'string' ? Number.parseInt(input) : input;

    if (Number.isNaN(sizeInKB) || sizeInKB < 0) {
        return 'Invalid size';
    }

    const units = ['KB', 'MB', 'GB', 'TB'];
    let size = sizeInKB;
    let unitIndex = 0;

    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }

    return `${size.toFixed(2)} ${units[unitIndex]}`;
};

export const urlValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
        return null;
    }

    const url = control.value.trim();

    if (url === '') {
        return null;
    }

    const urlRegex =
        /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/; // NOSONAR

    return urlRegex.test(url) ? null : { invalidUrl: true };
};

export const linkedinUrlValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const url = control.value.trim();
    if (url === '') return null;

    const linkedinRegex = /^https?:\/\/(www\.)?linkedin\.com\/.+$/i;
    return linkedinRegex.test(url) ? null : { invalidLinkedinUrl: true };
};

export const emailValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    
    const email = control.value.trim();
    if (email === '') return null;
    
    const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    
    return emailRegex.test(email) ? null : { invalidEmail: true };
};

export const fullNameValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const nameParts = String(control.value).trim().split(/\s+/);
    return nameParts.length >= 2 ? null : { invalidFullName: true };
};
